export const setDigitalSignageCategory = (facility: any, value: boolean) => {
    facility.noticeboardEnabled = value;
    facility.isStaffHubContentManagerDigitalSignage = value;
    facility.isStaffHubDevicesColumnDigitalSignage = value;
    facility.isStaffHubContentManagerMediaCreator = value;
}